// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__30xoB","obliqueLineWrap":"membershipbadge_obliqueLineWrap__BLpUX","obliqueLine":"membershipbadge_obliqueLine__Nx9nR"};